/*
Item: Form to display all Standardtabellen depending on selected statistic
Name: TableStandard
Format: Frontend component, partial screen
Input: via URL &-argument
*/

import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
// import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MultiSelect } from 'primereact/multiselect';
import JsonHelper, {
  StatisticsNames, StatisticsNamesShort, HeadingNames,
  StatisticNumbers, CategoryEnums, TypeNames, changeVariables,
} from '../utils/statisticsUtils';
import NodeService from '../service/NodeService';
import MessageService from '../service/MessageService';
import TreeTableWrapper from '../components/TreeTableWrapper';
import StandardFoldersEditDialogW from '../components/dialogue/StandardFoldersEditDialogW';

const DialogType = Object.freeze({
  none: 0,
  delete: 1,
  rename: 2,
  copyItem: 3,
  switchLoc: 4, // switch location
});

export default class TablesStandard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Bund? Land?
      group: sessionStorage.getItem('group'),
      // type of current editDialog
      currentDialogType: DialogType.none,
      // currentSelectedNode in TreeTable
      currentNode: undefined,
      // new Name for renameing or creating node
      newNodeDataName: undefined,
      // allNodes
      allNodes: [],
      // key of the node which is selected as new father node in the edit dialog
      selectedTreeNodeKey: undefined,
      // state for wait spinner dialog
      visibleWait: true,
    };
    this.messageService = new MessageService();
    this.nodeservice = new NodeService();
    this.actionTemplate = this.actionTemplate.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
    this.getDirectory = this.getDirectory.bind(this);
    this.onHide = this.onHide.bind(this);
    this.setNewNodeDataName = this.setNewNodeDataName.bind(this);
    this.setSelectedTreeNodeKey = this.setSelectedTreeNodeKey.bind(this);
    this.loadNode = this.loadNode.bind(this);
    // this.moveNode = this.moveNode.bind(this);
    // this.insertNode = this.insertNode.bind(this);
    // this.deleteNode = this.deleteNode.bind(this);
    this.launchStatistics = this.launchStatistics.bind(this);
    this.myTreeTable = React.createRef();
  }

  componentDidMount = async () => {
    const onlyTable = true;
    await this.nodeservice.getTreeTableNodes('assets/treetablenodesall.json').then((data) => this.setState({ allNodes: data }));
    this.setState({ visibleWait: true });
    const right = 'ALL'; // TableSavedNames[statistic][2];
    try {
      const statisticName = window.location.href.split('&')[1];
      // ### load categories ###
      let type = 'ordercriterion';
      let objectTyp = 'ORDERCRITERION';
      let objectNumber = '109'; // STRUCTURE=108
      let prefix = '0';
      const statisticLink = [
        {
          '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
          type: 'STATISTIC',
          name: statisticName,
          reference: null,
          id: -1,
          shortDescription: '',
          idList: [],
        },
      ];
      const loadedCategories = await this.getDirectory(type, right, objectNumber, objectTyp,
        prefix, undefined, onlyTable, statisticLink);
      const { allNodes } = this.state;
      const findKey = {};
      // ### load standard tables ###
      type = 'structure';
      objectTyp = 'STRUCTURE';
      objectNumber = '108';
      prefix = '1';
      // filtered by categories-array per statistic (order criterion)
      const linksArray = [{
        '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
        type: 'ORDERCRITERION',
        name: '',
        reference: null,
        id: -1,
        shortDescription: '',
        idList: [],
      }];
      const idList = [];
      for (let i = 0; i < loadedCategories.length; i += 1) {
        idList[i] = loadedCategories[i].data.id;
      }
      linksArray[0].idList = idList;
      const loadedTables = await this.getDirectory(type, right, objectNumber, objectTyp,
        prefix, undefined, onlyTable, linksArray);
      // über alle in children
      const statistic = StatisticNumbers[statisticName];
      for (let i = 0; i < loadedCategories.length; i += 1) {
        const nodeStatistic = StatisticNumbers[loadedCategories[i].data.statisticName];
        const { name } = loadedCategories[i].data;
        const { id } = loadedCategories[i].data;
        const category = CategoryEnums[loadedCategories[i].data.topicType];
        const subCategory = allNodes[nodeStatistic].children[category].children.length;
        const insertItem = {
          key: '',
          data: {
            name: '', id: 0, statistic: 0, category: 0,
          },
          category: 'Kategorie',
          objectNumber: '109',
          type: 'ordercriterion',
          canMoveOrDelete: false,
          selectable: false,
        };
        const key = `${nodeStatistic}-${category}-${subCategory}`;
        // findKey[name] = key;
        // console.log('loaded# id', name, id, key);
        findKey[id] = key;
        insertItem.key = key;
        insertItem.data.name = name;
        insertItem.data.id = id;
        insertItem.data.statistic = nodeStatistic;
        insertItem.data.category = category;
        allNodes[nodeStatistic].children[category].children[subCategory] = insertItem;
      }
      const result = allNodes[statistic].children;
      // über alle geladenen Tabellen
      for (let j = 0; j < loadedTables.length; j += 1) {
        const { name, id, orderCriterionReference } = loadedTables[j].data;
        if (findKey[orderCriterionReference.id]) {
          const categoryKey = findKey[orderCriterionReference.id];
          const nodeStatistic = categoryKey.split('-')[0];
          const category = categoryKey.split('-')[1];
          const subCategory = categoryKey.split('-')[2];
          let lastCategory;
          if (!allNodes[nodeStatistic].children[category].children[subCategory].children) {
            lastCategory = 0;
          } else {
            lastCategory = allNodes[nodeStatistic].children[category].children[subCategory].children.length;
          }
          const key = `${categoryKey}-${lastCategory}`;
          const newInsertItem = {
            key: '',
            data: {
              name: '',
              id: 0,
              statistic: 0,
              category: 0,
            },
            category: 'Tabelle',
            objectNumber: '108',
            type: 'structure',
            canMoveOrDelete: true,
            selectable: true,
          };
          newInsertItem.key = key;
          newInsertItem.data.name = name;
          newInsertItem.data.id = id;
          newInsertItem.data.statistic = nodeStatistic;
          newInsertItem.data.category = category;
          if (!allNodes[nodeStatistic].children[category].children[subCategory].children) {
            allNodes[nodeStatistic].children[category].children[subCategory].children = [];
          }
          allNodes[nodeStatistic].children[category].children[subCategory].children[lastCategory] = newInsertItem;
        }
      }
      this.setState({ allNodes: result }); // only for this statistic
    } catch (e) {
      console.log('### ERROR', e);
    } finally {
      this.setState({ visibleWait: false });
    }
  }

  handleYes() {
    const { objectTable, objectTableNew, loc } = this.state;
    this.setState({
      visibleLoadSelect: false,
    });
    sessionStorage.setItem('evaluationRegional', loc);
    // console.log('LAND#1', loc, objectTableNew);
    let objT = objectTable;
    if (loc === 'Land') {
      // console.log('LAND#2', objectTableNew);
      // return;
      objT = JsonHelper.deepCopy(objectTableNew); // causes error loading
    }
    this.loadNodeFinally(objT);
  }

  handleYesProd() {
    const { objectTable, objectTableNew, loc } = this.state;
    this.setState({
      visibleLoadSelect: false,
    });
    sessionStorage.setItem('evaluationRegional', loc);
    const { entrys } = objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel;
    const jsonStructure = JSON.parse(entrys[0].jsonStructure);
    const { selectedStatistics } = jsonStructure;
    const st = [];
    for (let j = 0; j < selectedStatistics.length; j += 1) {
      st.push(selectedStatistics[j].name);
    }
    sessionStorage.setItem('evaluationStatistics', st); // selectedStatistics als array
    if (loc === 'Land') {
      this.loadNodeFinally(objectTableNew);
    } else {
      this.loadNodeFinally(objectTable);
    }
  }

  handleCancel() {
    this.setState({
      visibleLoadSelect: false,
      objectTable: undefined,
      objectTableNew: undefined,
    });
  }

  onHide() {
    this.setState({
      currentDialogType: DialogType.none,
      currentNode: undefined,
      newNodeDataName: undefined,
      selectedTreeNodeKey: undefined,
    });
  }

  setSelectedTreeNodeKey(newFatherNodeKey) {
    this.setState({ selectedTreeNodeKey: newFatherNodeKey });
  }

  setNewNodeDataName(name) {
    this.setState({ newNodeDataName: name });
  }

  async getDirectory(type, right, objectNumber, objectTyp,
    prefix, typeString, onlyTable, linksArray) {
    const ch = [];
    const path = 'directory';
    const elementsData1 = await this.messageService.postVariableDirectory(
      path, type, right, objectNumber, objectTyp, typeString, onlyTable, linksArray,
    );
    // let children = [];
    if (elementsData1[0]) {
      this.growl.show({ severity: elementsData1[1], summary: `Hinweis zu ${TypeNames[type]}`, detail: elementsData1[0] });
    } else {
      const entries = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      for (let ii = 0; ii < entries.length; ii += 1) {
        ch[ii] = {};
        ch[ii].key = `${prefix}-${ii}`;
        ch[ii].type = type;
        ch[ii].objectNumber = objectNumber;
        ch[ii].data = {};
        ch[ii].data.name = entries[ii].name;
        ch[ii].data.date = entries[ii].modifiedTime;
        ch[ii].data.id = entries[ii].id;
        ch[ii].data.topicType = entries[ii].topicType;
        ch[ii].data.statisticName = entries[ii].statisticName;
        ch[ii].data.typ = entries[ii].typ;
        ch[ii].data.orderCriterionId = entries[ii].orderCriterionId;
        ch[ii].data.orderCriterionReference = entries[ii].orderCriterionReference;
      }
    }
    if (elementsData1[2] === -1) {
      window.location.replace(`${process.env.PUBLIC_URL}/login`);
    }
    return ch;
  }

  launchStatistics(structure) {
    const { history } = this.props;
    history.push({
      state: {
        loadedTable: structure,
      },
      pathname: '/evaluation/statistics',
    });
  }

  async doSwitchLoc() {
    const {
      currentNode,
      // newNodeDataName,
      selectedTreeNodeKey,
      // currentDialogType,
    } = this.state;
    let { allNodes } = this.state;
    const { key } = currentNode;
    const currentNodeEnvironment = this.myTreeTable.current.findNodeEnvironment(allNodes, key, 1);
    let { nodesArray } = currentNodeEnvironment;
    const node = nodesArray[currentNodeEnvironment.position];
    // let success;
    this.setState({ visibleWait: true });
    // updade node in backend
    const arrSelectedTreeNodeKey = selectedTreeNodeKey.split('-');
    const folderSubCategory = arrSelectedTreeNodeKey[1];
    const ordercriterionCount = arrSelectedTreeNodeKey[2];
    const moveToId = allNodes[folderSubCategory].children[ordercriterionCount].data.id;
    let objectNumber = 109; // ordercriterion
    let type = 'ordercriterion';
    const elementsDataFolder = await this.messageService.postRecordStructureProperties(
      moveToId, objectNumber, type, false,
    );
    const { entrys } = elementsDataFolder.contents['genesis.container.content.GenesisTMContent'].transfermodel;
    const { id } = node.data;
    objectNumber = 108; // structure
    type = 'structure';
    const elementsData = await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false,
    );
    const link = 'update';
    const insertMessage = JsonHelper.deepCopy(elementsData);
    insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId = moveToId;
    insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference = entrys[0];
    await this.messageService.postRecordStructureProperties(
      id, objectNumber, type, false, undefined, insertMessage, link,
    );
    // delete selected node in Frontend
    nodesArray.splice(currentNodeEnvironment.position, 1);
    const nodesArrayA = JsonHelper.deepCopy(nodesArray);
    const res = this.myTreeTable.current.updateKeyOfItemAndChildItems(
      nodesArrayA, currentNodeEnvironment.position, currentNodeEnvironment.depth,
    );
    nodesArray = res;
    allNodes = JsonHelper.deepCopy(allNodes);
    const splitKey = key.split('-');
    allNodes[splitKey[1]].children[splitKey[2]].children = nodesArray;
    // move node
    const arrInsert = selectedTreeNodeKey.split('-');
    const insertSubCategory = arrInsert[1];
    const insertFolder = arrInsert[2];
    if (!allNodes[insertSubCategory].children[insertFolder].children) {
      const children = [{ children: [] }];
      allNodes[insertSubCategory].children[insertFolder]['children'] = [];
    }
    const pos = allNodes[insertSubCategory].children[insertFolder].children.length;
    const newKey = `${selectedTreeNodeKey}-${pos}`;
    node.key = newKey;
    allNodes[insertSubCategory].children[insertFolder].children[pos] = node;
    return allNodes;
  }

  async confirmDialog() {
    const {
      currentNode,
      newNodeDataName,
      // selectedTreeNodeKey,
      currentDialogType,
    } = this.state;
    let { allNodes } = this.state;
    const { key } = currentNode;
    const currentNodeEnvironment = this.myTreeTable.current.findNodeEnvironment(allNodes, key, 1);
    // const { nodesArray } = currentNodeEnvironment;
    // let newAllNodes;
    // const node = nodesArray[currentNodeEnvironment.position];
    let success;
    switch (currentDialogType) {
      case DialogType.delete:
        success = await this.deleteNode(currentNodeEnvironment);
        break;
      case DialogType.rename:
        success = await this.renameNode(currentNodeEnvironment);
        if (success) {
          // umbenennen im FE
          currentNodeEnvironment.nodesArray[
            currentNodeEnvironment.position].data.name = newNodeDataName;
        }
        break;
      case DialogType.copyItem:
        // await this.myTreeTable.current.insertNode(currentNodeEnvironment, newNodeObj);
        break;
      case DialogType.switchLoc:
        allNodes = await this.doSwitchLoc();
        // allNodes = newAllNodes;
        /*
        this.setState({ visibleWait: true });
        // updade node in backend
        let arrSelectedTreeNodeKey = selectedTreeNodeKey.split('-');
        let folderSubCategory = arrSelectedTreeNodeKey[1];
        let ordercriterionCount = arrSelectedTreeNodeKey[2];
        let moveToId = allNodes[folderSubCategory].children[ordercriterionCount].data.id;
        let objectNumber = 109; // ordercriterion
        let type = 'ordercriterion';
        const elementsDataFolder = await this.messageService.postRecordStructureProperties(
          moveToId, objectNumber, type, false,
        );
        let { entrys } = elementsDataFolder.contents['genesis.container.content.GenesisTMContent'].transfermodel;
        let { id } = node.data;
        objectNumber = 108; // structure
        type = 'structure';
        const elementsData = await this.messageService.postRecordStructureProperties(
          id, objectNumber, type, false,
        );
        const oldId = elementsData.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId;
        const oldData = elementsData.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference;
        let link = 'update';
        const insertMessage = JsonHelper.deepCopy(elementsData);
        insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionId = moveToId;
        insertMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].orderCriterionReference = entrys[0];
        await this.messageService.postRecordStructureProperties(
          id, objectNumber, type, false, undefined, insertMessage, link,
        );
        // delete selected node in Frontend
        nodesArray.splice(currentNodeEnvironment.position, 1);
        const nodesArrayA = JsonHelper.deepCopy(nodesArray);
        const res = this.myTreeTable.current.updateKeyOfItemAndChildItems(
          nodesArrayA, currentNodeEnvironment.position, currentNodeEnvironment.depth,
        );
        nodesArray = res;
        let allNodes = JsonHelper.deepCopy(allNodes);
        const splitKey = key.split('-');
        allNodes[splitKey[1]].children[splitKey[2]].children = nodesArray;
        // move node
        let arrInsert = selectedTreeNodeKey.split('-');
        const insertSubCategory = arrInsert[1];
        const insertFolder = arrInsert[2];
        if (!allNodes[insertSubCategory].children[insertFolder].children) {
          let children = [{ children: [] }];
          allNodes[insertSubCategory].children[insertFolder]['children'] = [];
        }
        let pos = allNodes[insertSubCategory].children[insertFolder].children.length;
        let newKey = `${selectedTreeNodeKey}-${pos}`;
        node.key = newKey;
        allNodes[insertSubCategory].children[insertFolder].children[pos] = node;
        */
        break;
      default:
    }
    this.setState({ allNodes, visibleWait: false }, () => this.onHide());
  }

  async deleteNode(currentNodeEnvironment) {
    let success = true;
    const { nodesArray } = currentNodeEnvironment;
    const node = nodesArray[currentNodeEnvironment.position];
    const { id } = node.data;
    const { objectNumber } = node;
    const { type } = node;
    const { newNodeDataName } = this.state;
    this.setState({ visibleWait: true });
    try {
      const elementsData = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false,
      );
      if (elementsData[0]) {
        success = false;
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
      } else {
        const insertMessage = JsonHelper.deepCopy(elementsData);
        // remove selection from parameter-hashmap in message to prevent
        // searching for id instead of FachId which would work here
        insertMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.selektion = [];
        const link = 'delete';
        const ret = await this.messageService.postRecordStructureProperties(
          id, objectNumber, type, false, undefined, insertMessage, link,
        );
        // e.g. 5 109 'ordercriterion' false undefined ? delete
        if (ret[0]) {
          if (ret[3] === 18129) {
            success = false;
            const message = ret[0];
            const confirmation = ret[2];
            // anzeigen Dialog
            this.setState({
              visibleYn: true,
              message,
              tmpNodesArray: nodesArray,
              tmpNode: node,
              tmpCurrentNodeEnvironment: currentNodeEnvironment,
              confirmation,
            });
            // nodesArray.splice(currentNodeEnvironment.position, 1); // Zeile im FE entfernen
            if (newNodeDataName) node.data.name = newNodeDataName; // nicht hinter dem await!
          } else {
            success = false;
            const message = ret[0].replace('java.lang.Exception:', '');
            this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
          }
        } else {
          // nothing
        }
      }
      if (success) {
        await this.myTreeTable.current.deleteNode(currentNodeEnvironment, false);
      }
    } catch (e) {
      console.log('### ERROR in deleteNode', e);
    } finally {
      this.setState({ visibleWait: false });
    }
    return success;
  }

  updateKeyOfItemAndChildItems(nodesArrayInput, startIndex, keyChangePosition) {
    // let node;
    // let oldKeySplit;
    // keyChangePosition = 3;
    const nodesArray = JsonHelper.deepCopy(nodesArrayInput);
    const startNumber = Number(startIndex);
    for (let counter = startNumber; counter < nodesArray.length; counter += 1) {
      const node = nodesArray[counter];
      const oldKeySplit = node.key.split('-');
      oldKeySplit[keyChangePosition - 1] -= 1; // changed for 471 to keyChangePosition-1
      const newKey = oldKeySplit.join('-');
      node.key = newKey;
      if (node.children) {
        node.children = this.updateKeyOfItemAndChildItems(node.children, 0, keyChangePosition);
      }
    }
    return nodesArray;
  }

  openDialog(node, type) {
    const newState = { currentDialogType: type, currentNode: node };
    if (type === DialogType.rename) {
      newState.newNodeDataName = node.data.name;
    }
    this.setState(newState);
  }

  iterateChilden(element, res, d) {
    let depth = d;
    const { children } = element;
    for (let n = 0; n < children.length; n += 1) {
      // console.log('ITERATE#', children[n]);
      const { name, variableType, mutableVariablesReference } = children[n];
      const { length } = mutableVariablesReference;
      if (variableType === 'REGION_CLASSIFYING') {
        const notInArray = res.indexOf(name) === -1;
        const hasElements = length > 0;
        if (notInArray && hasElements) res.push(name);
      }
      if (children[n].children.length > 0) {
        depth += 1;
        this.iterateChilden(children[n], res, depth);
      }
    }
    return res;
  }

  iterateNames(structure) {
    let res = [];
    for (let i = 0; i < structure.length; i += 1) {
      res = this.iterateChilden(structure[i], res, 0);
    }
    return res;
  }

  async loadNode(node, loadTable) { // param currentNode
    sessionStorage.setItem('loadTable', loadTable);
    // let success = true;
    let wasSwitchedToLand = false;
    let namesToChange = [];
    const arrRefItem = [];
    const arrNewItem = [];
    const { group } = this.state;
    const { typ, id } = node.data;
    const objectNumber = '108';
    const type = 'structure';
    const openDialog = (group !== 'StBA'); // Standardtab.
    const locs = [
      { label: 'Bund', value: 'Bund' },
      { label: 'Land', value: 'Land' },
    ];
    const loc = 'Bund';
    let state = '';
    if (openDialog) state = group.slice(group.length - 2, group.length);
    this.setState({ visibleWait: true });
    try {
      const elementsData = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false,
      );
      if (elementsData[0]) {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
        // success = false;
      } else {
        const objectTableNew = JsonHelper.deepCopy(elementsData); // set for 'Land'
        const objectTable = JsonHelper.deepCopy(elementsData); // new selected set
        if (openDialog) {
          // get all possible values
          const { structureAxis } = elementsData.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
          const newStructureAxis = JsonHelper.deepCopy(structureAxis);
          const { entrys } = objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel;
          const jsonStructure = JSON.parse(entrys[0].jsonStructure);
          // Namen rekursiv
          namesToChange = this.iterateNames(structureAxis);
          const landPrefix = group.slice(group.length - 2, group.length);
          // end Namen
          /* //neuer Test
          const landPrefix = group.slice(group.length - 2, group.length);
          for (let mm = 0; mm < changeVariables.length; mm += 1) {
            const chVarName = changeVariables[mm];
            if (jsonStructure[changeVariables[mm]].length !== 0) {
              if (chVarName.substr(chVarName.length - 6) !== '_graph') {
                const jsonObj = jsonStructure[chVarName];
                for (let oo = 0; oo < jsonObj.length; oo += 1) {
                  if (jsonObj[oo].type === 'REGION_CLASSIFYING') {
                    console.log('TEST#04#Obj', jsonObj[oo].name);
                    console.log('TEST#05#Name', jsonObj[oo].name);
                  }
                }
              }
            }
          }
          */ //Ende neuer Test
          for (let i = 0; i < structureAxis.length; i += 1) {
            for (let j = 0; j < structureAxis[i].children.length; j += 1) {
              const { mutableVariablesReference } = structureAxis[i].children[j];
              if (mutableVariablesReference.length > 1) {
                arrRefItem[arrRefItem.length] = mutableVariablesReference[0];
                for (let k = 0;
                  k < mutableVariablesReference.length;
                  k += 1) {
                  const refName = mutableVariablesReference[k].name;
                  // console.log('TEST#0-', refName, structureAxis);
                  if (refName.substring(0, 2) === state) {
                    for (let m = 0; m < changeVariables.length; m += 1) {
                      if (jsonStructure[changeVariables[m]].length !== 0) {
                        for (let n = 0; n < jsonStructure[changeVariables[m]].length; n += 1) {
                          if (jsonStructure[changeVariables[m]][n].type === 'REGION_CLASSIFYING') {
                            // console.log('LAND#0-', jsonStructure[changeVariables[m]][n]);
                            if (jsonStructure[changeVariables[m]][n].mutableVariablesReference.length > 0) {
                              wasSwitchedToLand = true;
                              // console.log('LAND#00', wasSwitchedToLand);
                              const test = mutableVariablesReference[k];
                              test['@class'] = 'genesis.transfer.model.dto.display.StructureElementDTO';
                              // Austauschen
                              // console.log('TAUSCH#', jsonStructure[changeVariables[m]][n], mutableVariablesReference[k]);
                              jsonStructure[changeVariables[m]][n] = mutableVariablesReference[k];
                              // Filter, Regeln löschen
                              // ...
                            }
                          }
                        }
                      }
                    }
                    const tmpRef = JsonHelper.deepCopy(newStructureAxis[i].children[j]);
                    const tmpLand1 = JsonHelper.deepCopy(mutableVariablesReference[k]);
                    const tmpLand = tmpRef;
                    // console.log('LAND#0--', tmpRef);
                    tmpLand.name = refName;
                    tmpLand.formatings.name = refName;
                    tmpLand.output[0].name = refName;
                    tmpLand.output[0].reference = tmpLand1;
                    tmpLand.mutableVariablesReference = [];
                    wasSwitchedToLand = true;
                    // TODO selection entfernen
                    delete tmpLand.topic;
                    const replaceNode = tmpLand;
                    arrNewItem[arrNewItem.length] = tmpLand; // TODO check
                    newStructureAxis[i].children[j] = replaceNode;
                  }
                }
              }
            }
          }
          objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].structureAxis = newStructureAxis;
          sessionStorage.setItem('evaluationRegional', loc);
          // console.log('GROUP#5', objectTable);
          // console.log('GROUP#6', objectTableNew);
          const { selectedStatistics } = jsonStructure;
          const st = [];
          for (let j = 0; j < selectedStatistics.length; j += 1) {
            st.push(selectedStatistics[j].name);
          }
          sessionStorage.setItem('evaluationStatistics', st); // selectedStatistics als array
          // console.log('LAND#01', wasSwitchedToLand);
          this.setState({
            loc,
            locs,
            objectTable,
            objectTableNew,
            visibleLoadSelect: true,
            arrRefItem,
            arrNewItem,
            wasSwitchedToLand,
            namesToChange,
            landPrefix,
          });
        } else {
          sessionStorage.setItem('evaluationRegional', loc);
          const { entrys } = objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel; // TODO check if New can be deteted
          const jsonStructure = JSON.parse(entrys[0].jsonStructure);
          // jsonStructure.tableRendered = { nothing: `id${(new Date()).getTime()}`};
          const { selectedStatistics } = jsonStructure;
          const st = [];
          for (let j = 0; j < selectedStatistics.length; j += 1) {
            st.push(selectedStatistics[j].name);
          }
          sessionStorage.setItem('evaluationStatistics', st); // selectedStatistics als array
          await this.loadNodeFinally(objectTable);
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error in loadNode: ', err);
    } finally {
      this.setState({ visibleWait: false });
    }
    // return success;
  }

  async loadNodeOld(node) { // param currentNode
    // let success = true;
    const arrRefItem = [];
    const arrNewItem = [];
    const { group } = this.state;
    const { id } = node.data;
    const objectNumber = '108';
    const type = 'structure';
    const openDialog = (group !== 'StBA');
    const locs = [
      { label: 'Bund', value: 'Bund' },
      { label: 'Land', value: 'Land' },
    ];
    const loc = 'Bund';
    let state = '';
    if (openDialog) state = group.slice(group.length - 2, group.length);
    this.setState({ visibleWait: true });
    try {
      const elementsData = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false,
      );
      if (elementsData[0]) {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
        // success = false;
      } else {
        const objectTableNew = JsonHelper.deepCopy(elementsData);
        const objectTable = JsonHelper.deepCopy(elementsData);
        if (openDialog) {
          // get all possible values
          const { structureAxis } = elementsData.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
          const newStructureAxis = JsonHelper.deepCopy(structureAxis);
          for (let i = 0; i < structureAxis.length; i += 1) {
            for (let j = 0; j < structureAxis[i].children.length; j += 1) {
              if (structureAxis[i].children[j].mutableVariablesReference.length > 1) {
                arrRefItem[arrRefItem.length] = structureAxis[i].children[j].mutableVariablesReference[0];
                for (let k = 0;
                  k < structureAxis[i].children[j].mutableVariablesReference.length;
                  k += 1) {
                  const refName = structureAxis[i].children[j].mutableVariablesReference[k].name;
                  if (refName.substring(0, 2) === state) {
                    const tmp5 = JsonHelper.deepCopy(structureAxis[i].children[j].mutableVariablesReference[k]);
                    const replaceNode = structureAxis[i].children[j].mutableVariablesReference[k];
                    arrNewItem[arrNewItem.length] = tmp5;
                    newStructureAxis[i].children[j] = replaceNode;
                  }
                }
              }
            }
          }
          const objectTableNew = JsonHelper.deepCopy(elementsData);
          objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].structureAxis = newStructureAxis;
          this.setState({
            loc,
            locs,
            objectTable,
            objectTableNew,
            visibleLoadSelect: true,
            arrRefItem,
            arrNewItem,
          });
        } else {
          sessionStorage.setItem('evaluationRegional', loc);
          const { entrys } = objectTableNew.contents['genesis.container.content.GenesisTMContent'].transfermodel;
          const jsonStructure = JSON.parse(entrys[0].jsonStructure);
          const { selectedStatistics } = jsonStructure;
          const st = [];
          for (let j = 0; j < selectedStatistics.length; j += 1) {
            st.push(selectedStatistics[j].name);
          }
          sessionStorage.setItem('evaluationStatistics', st); // selectedStatistics als array
          await this.loadNodeFinally(objectTable);
        }
      }
    } catch (err) {
      console.log('Error in loadNode: ', err);
    } finally {
      this.setState({ visibleWait: false });
    }
    // return success;
  }

  async preloadTableCheck(loadedTable) {
    // console.log('preload#');
    let tree;
    let loadedTableSt = loadedTable.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
    loadedTableSt = JsonHelper.deepCopy(loadedTableSt);
    if (loadedTableSt.typ === 'DEFAULT') {
      loadedTableSt.typ = 'STRUCTURE';
    }
    const tableTyp = loadedTableSt.typ;
    let firstDataSuccess = true;
    const { jsonStructure } = loadedTableSt;
    // console.log('TABLE#', jsonStructure);
    if (jsonStructure === null) {
      firstDataSuccess = false;
    } else {
      const loadedStructure = JSON.parse(loadedTableSt.jsonStructure);
      loadedStructure.tableTyp = tableTyp;
      delete loadedStructure.saveTableVisible;
      // const { valueEmptyLines } = loadedStructure;
      let { value } = loadedStructure;
      this.setState({ visible: true });
      if (typeof value === 'undefined') value = this.state.value;
      const retrievalObj = {
        link: 'valueretrieval',
        tree,
        loadedTable,
        notShowSecretValues: value,
        zusatzfilter: ["json"],
      };
      const returnMessage = await this.messageService.postValueRetrievalStart(retrievalObj);
      this.setState({ visible: false });
      if (returnMessage[1] === 'error') {
        const errNum = returnMessage[2];
        const checkError = returnMessage[0];
        let displayError = 'Ein unbekannter Fehler ist aufgetreten.';
        if (errNum === 7000) {
          displayError = 'Tabelle nicht mehr abrufbar (verwendete Regel oder Daten nicht mehr vorhanden)';
        } else if (errNum === 1191 || errNum === 1193 || errNum === 1194) {
          displayError = 'Tabelle ist nicht mehr abrufbar';
        } else if (checkError === 'javax.ejb.EJBTransactionRolledbackException: genesis.transfer.model.dto.RetrievalJobDTO cannot be cast to genesis.transfer.model.gom.GOMContainer') {
          // displayError = 'Die Anfrage liefert zu viele Werte zurück.';
          displayError = checkError;
        } else {
          displayError = checkError;
        }
        this.growl.show({
          life: 12000,
          severity: returnMessage[1],
          summary: 'Fehler',
          detail: displayError,
        });
        firstDataSuccess = false;
      }
    }
    return firstDataSuccess;
  }

  async loadNodeFinally(objectTable) {
    // console.log('LAND#3', objectTable);
    const {
      arrRefItem,
      arrNewItem,
      wasSwitchedToLand,
      namesToChange,
      landPrefix,
    } = this.state;
    // console.log('LAND#3.1', wasSwitchedToLand);
    const loadedTable = objectTable;
    let cont;
    try {
      this.setState({ visibleWait: true });
      cont = await this.preloadTableCheck(loadedTable);
    } catch (err) {
      console.log('error in loadNodeFinally', err, cont);
    } finally {
      this.setState({ visibleWait: false });
      this.props.history.push({
        pathname: '/evaluation/statistics',
        state: {
          loadedTable: objectTable,
          arrRefItem,
          arrNewItem,
          wasSwitchedToLand,
          namesToChange,
          landPrefix,
        },
      });
    }
  }

  async loadNodeFinallyOld(loadedTable) {
    const { arrRefItem, arrNewItem } = this.state;
    // This does not work in Firefox due to state size limitation.
    // A Soulution would be to put the loaded table in the pouchdb
    // with a unique ID, save the ID in the state and get the
    // loaded table fron the pouchdb by ID before deleting it.
    // Shoud be simple.
    // s. ticket ADBHSSTAT-1036
    // console.log('SIGN#', loadedTable);
    this.props.history.push({
      pathname: '/evaluation/statistics',
      state: {
        loadedTable,
        arrRefItem,
        arrNewItem,
        // loadedLocation: loc,
      },
    });
  }

  actionTemplate(node) {
    const { selectable } = node;
    const isAdmin = sessionStorage.getItem('role') === 'GROUP_ADMIN' && sessionStorage.getItem('group') === 'StBA';
    const showMoveAndCopy = isAdmin && node.canMoveOrDelete;
    // const showOpen = isAdmin && node.canMoveOrDelete;
    return (
      <div>
        {selectable ? (
          <span>
            <Button
              title="Tabelle öffnen"
              type="button"
              icon="pi-md-arrowstop-1-e"
              className="p-button-success"
              onClick={() => this.loadNode(node, 'true')}
            />
          </span>
        ) : undefined}
        {showMoveAndCopy ? (
          <span>
            <Button
              title="Verschieben"
              type="button"
              icon="pi-md-redo"
              className="p-button-success"
              onClick={() => this.openDialog(node, DialogType.switchLoc)}
            />
            <Button
              title="Löschen"
              type="button"
              icon="pi-md-delete-forever"
              className="p-button-danger"
              onClick={() => this.openDialog(node, DialogType.delete)}
            />
          </span>
        ) : undefined}
      </div>
    );
  }

  linkClick(address) {
    const { history } = this.props;
    history.push(`./${address}`);
  }

  returnDropdowns() {
    const {
      selectedCategory, year, years, semester, semesters, loc, locs,
    } = this.state;
    let returnHtml;
    if (selectedCategory === 'Standardtabelle') {
      returnHtml = (
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <div className="p-col-12 p-lg-12">
                <Dropdown value={year} options={years} onChange={(e) => { this.setState({ year: e.value }); }} placeholder="Berichtsjahr..." />
                <br />
                <p />
              </div>
              <div className="p-col-12 p-lg-12">
                <Dropdown value={semester} options={semesters} onChange={(e) => { this.setState({ semester: e.value }); }} placeholder="Berichtssemester..." />
                <br />
                <p />
              </div>
              <div className="p-col-12 p-lg-12">
                <MultiSelect value={loc} options={locs} onChange={(e) => { this.setState({ loc: e.value }); }} placeholder="Regionalauswahl..." />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      returnHtml = (
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <div className="p-col-12 p-lg-12">
                <b>
                  Bitte wählen Sie die Region aus, für die Sie die Standardtabelle öffnen möchten.
                </b>
              </div>
              <div className="p-col-12 p-lg-12">
                <Dropdown id="DrpDwn" value={loc} options={locs} onChange={(e) => { this.setState({ loc: e.value }); }} placeholder="Regionalauswahl" />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return returnHtml;
  }

  async confirmYnDialog() {
    const {
      newNodeDataName, tmpNodesArray, tmpNode, tmpCurrentNodeEnvironment, confirmation,
    } = this.state;
    this.setState({ visibleYn: false });
    let success = true;
    const ret = await this.messageService.postRecordStructureDelete(confirmation);
    // e.g. 5 109 'ordercriterion' false undefined ? delete
    if (ret[0]) {
      success = false;
      const message = ret[0].replace('java.lang.Exception:', '');
      this.growl.show({ severity: ret[1], summary: 'Hinweis', detail: message });
    } else {
      // nothing
    }
    if (success) {
      tmpNodesArray.splice(tmpCurrentNodeEnvironment.position, 1); // gelöschte Zeile entfernen
      tmpNode.data.name = newNodeDataName; // funktioniert nicht hinter dem await!
      this.updateKeyOfItemAndChildItems(
        tmpNodesArray, tmpCurrentNodeEnvironment.position, tmpCurrentNodeEnvironment.depth,
      );
    }
  }

  returnHeader(statistic) {
    return;
    let header = 'Ihre verfügbaren Berichtszeiträume von ';
    const headerText = HeadingNames[statistic];
    const headerBegin = '(Beginn)';
    const headerEnd = '(Ende)';
    header = `${header + headerText} ${headerBegin} bis ${headerEnd}`;
    return header;
  }

  renderFooter() {
    return (
      <div>
        <Button
          id="continue"
          label="Öffnen"
          icon="pi pi-check"
          onClick={() => this.handleYes()}
        />
        <Button
          id="cancel"
          label="Abbrechen"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => this.handleCancel()}
        />
      </div>
    );
  }

  renderYnFooter() {
    const { onHide, confirmDialog } = this.props;
    return (
      <div>
        <Button
          id="yes"
          label="Ja"
          icon="pi pi-check"
          onClick={() => this.confirmYnDialog()}
        />
        <Button
          id="no"
          label="Nein"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => this.setState({ visibleYn: false })}
        />
      </div>
    );
  }

  render() {
    const {
      currentNode,
      currentDialogType,
      visibleWait,
      allNodes,
      selectedTreeNodeKey,
      newNodeDataName,
      visibleYn,
      message,
      visibleLoadSelect,
      selectedCategory,
    } = this.state;
    const dspAllNodes = (allNodes.length > 2) ? [] : allNodes;
    const dspCategory = selectedCategory || 'Regionalauswahl';
    const statistic = window.location.href.split('&')[1];
    return (
      <div className="p-col-12 p-lg-12">
        {/* This Dialogue is for waiting */}
        <Dialog header="Lade Daten..." closable={false} closeOnEscape={false} visible={visibleWait} modal onHide={() => this.setState({ visibleWait: false })}>
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        {/* This Dialogue is for y/n selection */}
        <Dialog
          header="Löschen"
          closeOnEscape={false}
          visible={visibleYn}
          modal
          onHide={() => this.setState({ visibleYn: false })}
          footer={this.renderYnFooter()}
        >
          <div><p><h3>{message}</h3></p></div>
        </Dialog>
        {/* This Dialogue is a placeholder for selection of years etc. in standard tables */}
        <Dialog
          header={dspCategory}
          visible={visibleLoadSelect}
          style={{ width: '30vw' }}
          footer={this.renderFooter()}
          onHide={() => this.onHide()}
          modal
        >
          {this.returnDropdowns()}
        </Dialog>
        <Growl ref={(el) => { this.growl = el; }} />
        <h2>{StatisticsNames[statistic]}</h2>
        <h3>{this.returnHeader(statistic)}</h3>
        <div className="p-grid dashboard">
          <div
            role="button"
            id="evaluation"
            className="p-col-12 p-md-12"
            onClick={() => this.linkClick('evaluation')}
          >
            <div className="overview-box overview-box-2">
              <div className="overview-box-header" />
              <div className="overview-box-content">
                <div className="overview-box-icon"><i className="material-icons">apps</i></div>
                <div className="overview-box-title">Übergreifende und individuelle Auswertungen</div>
              </div>
            </div>
          </div>
          <div className="p-col-12 p-md-12">
            <TreeTableWrapper
              ref={this.myTreeTable}
              allNodes={dspAllNodes}
            >
              <Column
                field="name"
                header={`Standardtabellen ${StatisticsNamesShort[statistic]}`}
                expander
              />
              <Column
                header="Aktionen"
                body={this.actionTemplate}
                style={{ textAlign: 'right', width: '8rem' }}
              />
            </TreeTableWrapper>
            <StandardFoldersEditDialogW
              onHide={this.onHide}
              currentDialogType={currentDialogType}
              confirmDialog={this.confirmDialog}
              selectedTreeNodeKey={selectedTreeNodeKey}
              setSelectedTreeNodeKey={this.setSelectedTreeNodeKey}
              newNodeDataName={newNodeDataName}
              setNewNodeDataName={this.setNewNodeDataName}
              currentNode={currentNode}
              allNodes={allNodes}
            />
          </div>
        </div>
      </div>
    );
  }
}
